import React from "react";

import { Calendar, MapPin, Video, Phone, Clock } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

const typeIcons = {
  "Au cabinet": MapPin,
  Téléphonique: Phone,
  visio: Video,
};

function RDV({ rdvs }) {
  const sortedAppointments = [...rdvs].sort(
    (a, b) => new Date(b.dateRdv) - new Date(a.dateRdv)
  );

  return (
    <div className="min-h-screen ">
      <div className="max-w-4xl mx-auto mt-8">
        <div className="space-y-2">
          {sortedAppointments.length > 0 ? (
            <Section title="À venir" rdvs={sortedAppointments} />
          ) : (
            <div className="text-center py-16">
              <Calendar className="w-16 h-16 text-slate-300 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-slate-800">
                Aucun rendez-vous
              </h3>
              <p className="text-slate-500 mt-1">
                Prenez votre premier rendez-vous
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Section({ title, rdvs, faded = false }) {
  const getStatusBadge = (status) => {
    const config = {
      EN_ATTENTE: {
        label: "En attente",
        className: "bg-amber-100 text-amber-800 ring-1 ring-amber-200",
      },
      CONFIRME: {
        label: "Confirmé",
        className: "bg-green-100 text-green-800 ring-1 ring-green-200",
      },
      PASSÉ: {
        label: "Passé",
        className: "bg-slate-100 text-slate-700 ring-1 ring-slate-200",
      },
      ANNULE: {
        label: "Annulé",
        className: "bg-red-100 text-red-800 ring-1 ring-red-200",
      },
      TERMINE: {
        label: "Terminé",
        className: "bg-blue-100 text-blue-800 ring-1 ring-blue-200",
      },
    };

    const badge = config[status] || {
      label: status,
      className: "bg-slate-100 text-slate-700 ring-1 ring-slate-200",
    };

    return (
      <span
        className={`
          inline-flex items-center
          px-3 py-1
          text-xs font-medium
          rounded-full
          whitespace-nowrap
          ${badge.className}
        `}
      >
        {badge.label}
      </span>
    );
  };

  return (
    <div>
      <h2 className="text-lg font-semibold text-slate-800 mb-4">{title}</h2>
      <div className="grid gap-4">
        {rdvs.map((appt) => {
          const TypeIcon = typeIcons[appt.type] || Calendar;
          const date = new Date(appt.dateRdv);

          return (
            <div
              key={appt.id}
              className={` border-slate-200 border-2 p-5  rounded-xl bg-white shadow-sm ${
                faded ? "opacity-75" : ""
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-[#840040] bg-opacity-10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <TypeIcon className="w-6 h-6 text-[#840040]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-800">
                      {appt.objetRdv}
                    </h3>
                    <div className="flex items-center gap-4 mt-2 text-sm text-slate-600">
                      <span className="flex items-center gap-1">
                        <Calendar className="w-4 h-4 text-slate-500" />
                        {format(date, "d MMMM yyyy", { locale: fr })}
                      </span>

                      <span className="flex items-center gap-1">
                        <Clock className="w-4 h-4 text-slate-500" />
                        {format(date, "HH:mm")}
                      </span>
                    </div>
                    <div className="mt-2 text-sm text-slate-600">
                      {appt.type}
                    </div>
                    <div className="mt-3 text-sm text-slate-600">
                      {appt.note}
                    </div>
                  </div>
                </div>
                {getStatusBadge(appt.etat)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RDV;
